import { IOrder } from '@/interfaces/order';
import { formatThaiDate } from '@/utils/dataUtils';
import React from 'react';

interface IProps {
  data: IOrder;
}

const TemplateOrderInfoSecond = ({ data }: IProps) => {
  return (
    <div className="flex w-full text-xs mt-2">
      <table
        border={1}
        cellSpacing={0}
        cellPadding={5}
        style={{
          width: '100%',
          border: '0.5px; black solid',
          borderCollapse: 'collapse',
        }}
      >
        <tr>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            <strong>
              อ้างอิงเลขใบสั่งซื้อ <br /> Reference PO No.
            </strong>
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            <strong>
              กำหนดชำระ (วัน) <br /> Credit term (Days)
            </strong>
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            <strong>
              วันกำหนดชำระ <br /> Due Date
            </strong>
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            <strong>
              การขนส่ง <br /> Transportation
            </strong>
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            <strong>
              พนักงานขาย <br /> Salesman
            </strong>
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            {data?.poNo}
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            {data?.creditTerm}
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            {formatThaiDate(data?.dueDate)}
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            {data?.transportation}
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            {data?.salesName}
          </td>
        </tr>
      </table>
    </div>
  );
};

export default TemplateOrderInfoSecond;
